import { Component } from 'react';
import PropTypes from 'react-proptypes';
import { connect } from 'react-redux';
import { ButtonComponent } from '@dnhb/node_package';
import { dispatchMapper } from '../wizard/actions';

class Disclaimer extends Component {
  render() {
    const { sync, children } = this.props;
    return (
      <div className="disclaimer-view">
        <h1>Disclaimer</h1>
        {children}
        <div className="input">
          <ButtonComponent
            value="Sluiten"
            name="cancel"
            id="cancel"
            label=""
            className="group col-xs-12"
            inputClassNames="rounded primary"
            showLabel={false}
            onClickHandler={() => sync('show_disclaimer', false)}
          />
        </div>
      </div>
    );
  }
}

Disclaimer.propTypes = {
  sync: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.instanceOf(Array),
  ]).isRequired,
};

Disclaimer.defaultProps = {};

export default connect(state => ({
  settings: state.settings,
  syncing: state.syncing,
  output: state.output,
  input: state.input,
}), dispatchMapper)(Disclaimer);
